module.exports = __webpack_public_path__ + "img/icon-historial-medico.e195a296.png";